export class PhoneInUseError extends Error {
  constructor() {
    super('Telefone ja cadastrado')
    this.name = 'PhoneInUseError'
  }
}
